import type { Issue } from 'validata';

export const formatIssues = (issues?: Issue[]): string | undefined => {
  if (!issues || issues.length === 0) return undefined;
  return issues
    .map((issue) => {
      switch (issue.reason) {
        case 'min-length': {
          const info = issue.info;
          if (info) {
            return `Length must be ${String(info.min ?? '?')} or more`;
          }
          return 'Too short';
        }
        case 'max-length': {
          const info = issue.info;
          if (info) {
            return `Length must be ${String(info.min ?? '?')} or less`;
          }
          return 'Too long';
        }
        case 'min': {
          const info = issue.info;
          if (info) return `Must be ${String(info.min ?? '?')} or more`;
          return 'Too small';
        }
        case 'max': {
          const info = issue.info;
          if (info) return `Must be ${String(info.min ?? '?')} or less`;
          return 'Too large';
        }
        case 'incorrect-type': {
          const info = issue.info;
          if (info) {
            return `Incorrect type, expected ${String(info.expectedType ?? '?')}`;
          }
          return 'Incorrect type';
        }
        case 'incorrect-format':
          return 'Incorrect format';
        case 'no-conversion':
          return 'Unexpected format';
        case 'validator':
          return 'Unexpected format';
        case 'regex':
          return 'Unexpected format';
        case 'unexpected-property':
          return 'Cannot set this property';
        case 'password-mismatch':
          return 'Does not match Password';
        default:
          return issue.reason;
      }
    })
    .join('; ');
};
